"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = { selectedList: [] };
        GState.bind(this, [
            'user',
            'tenant'
        ]);
        this.state.selectedList = this.state.user.learner.departments || [];
    },
    onSelect: async function (id) {
        let list = this.state.selectedList;
        list = !list.includes(id) ? [...new Set([
                ...list,
                id
            ])] : list.filter(each => {
            return each != id;
        });
        this.state.selectedList = list;
        GState.user.update({ departments: list.length ? list : null }, 'learner');
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Settings/Learner/sections/Departments.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Bx_template = require("../../../../../components/Bx/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Bx_tag = marko_loadTag(Bx_template),
    Locale_template = require("../../../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    marko_forIn = require("marko/dist/runtime/helpers/for-in"),
    Image_template = require("../../../../../components/Image/index.marko"),
    Image_tag = marko_loadTag(Image_template),
    WSAdapt_template = require("../../../../../components/WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    Row_template = require("../../../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    marko_attrs0 = {
        "class": "d-flex align-items-center",
        style: "height:50vh"
      },
    marko_attrs1 = {
        "class": "w-100 text-center"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("b97805"),
    marko_node0 = marko_createElement("br", null, "3", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node1 = marko_createElement("br", null, "4", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs2 = {
        "class": "font-medium-2"
      },
    marko_node2 = marko_createElement("br", null, "9", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs3 = {
        "class": "card-content"
      },
    marko_attrs4 = {
        "class": "card-text overflow-hidden font-medium-4",
        style: "color:inherit"
      },
    marko_attrs5 = {
        "class": "font-small-3 text-ellipsis-2 mb-0",
        style: "color:inherit"
      };

function render(input, out, __component, component, state) {
  var data = input;

  if (isEmpty(state.tenant.departments)) {
    out.be("div", marko_attrs0, "0", component);

    out.be("div", marko_attrs1, "1", component);

    Bx_tag({
        type: "building",
        class: "font-large-3 text-muted"
      }, out, __component, "2");

    out.n(marko_node0, component);

    out.n(marko_node1, component);

    out.be("p", null, "5", component);

    Locale_tag({
        renderBody: function(out) {
          out.t("No Department Found");
        }
      }, out, __component, "6");

    out.ee();

    out.ee();

    out.ee();
  } else {
    out.be("div", marko_attrs2, "7", component);

    Locale_tag({
        renderBody: function(out) {
          out.t("Which of our departments whould you like to join?");
        }
      }, out, __component, "8");

    out.ee();

    out.n(marko_node2, component);

    Row_tag({
        renderBody: function(out) {
          var $for$0 = 0;

          marko_forIn(state.tenant.departments, function(departmentId, { poster, name, description }) {
            const isSelected = state.selectedList.includes( departmentId )

            var $keyScope$0 = "[" + (($for$0++) + "]");

            WSAdapt_tag({
                ns: "col-md-6 col-12",
                qs: "col-md-6 col-12",
                hs: "col-md-12 col-12",
                renderBody: function(out) {
                  out.be("div", {
                      "class": "card cursor-pointer",
                      title: Locale(description)
                    }, "11" + $keyScope$0, component, null, 0, {
                      onclick: __component.d("click", "onSelect", false, [
                          departmentId
                        ])
                    });

                  out.be("div", marko_attrs3, "12" + $keyScope$0, component);

                  Row_tag({
                      class: "no-gutters",
                      renderBody: function(out) {
                        WSAdapt_tag({
                            ns: "col-3",
                            qs: "col-4",
                            hs: "col-3",
                            renderBody: function(out) {
                              Image_tag({
                                  alt: name,
                                  src: poster,
                                  class: "h-100 w-100 rounded-left"
                                }, out, __component, "15" + $keyScope$0);
                            }
                          }, out, __component, "14" + $keyScope$0);

                        out.be("div", {
                            "class": marko_classValue("col " + (isSelected ? "theme-bg-primary white-text" : ""))
                          }, "16" + $keyScope$0, component, null, 1);

                        out.be("div", {
                            "class": marko_classValue("card-body " + (isSelected ? "white-text" : "text-muted"))
                          }, "17" + $keyScope$0, component, null, 1);

                        out.be("div", marko_attrs4, "18" + $keyScope$0, component);

                        Locale_tag({
                            text: name
                          }, out, __component, "19" + $keyScope$0);

                        out.ee();

                        out.be("p", marko_attrs5, "20" + $keyScope$0, component);

                        Locale_tag({
                            text: description
                          }, out, __component, "21" + $keyScope$0);

                        out.ee();

                        out.ee();

                        out.ee();
                      }
                    }, out, __component, "13" + $keyScope$0);

                  out.ee();

                  out.ee();
                }
              }, out, __component, departmentId);
          });
        }
      }, out, __component, "10");
  }
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
